var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 256 512 z z z M 256 48 a 208 208 0 1 1 0 416 a 208 208 0 1 1 0 -416 z m 0 464 A 256 256 0 1 0 256 0 a 256 256 0 1 0 0 512 z z M 256 512 z m 0 -384 c 13.3 0 24 10.7 24 24 l 0 112 c 0 13.3 -10.7 24 -24 24 s -24 -10.7 -24 -24 l 0 -112 c 0 -13.3 10.7 -24 24 -24 z M 224 352 a 32 32 0 1 1 64 0 a 32 32 0 1 1 -64 0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWarning);
export default __webpack_public_path__ + "static/media/circle-warning.aebdc5cf3993054ec49d422a31b53005.svg";
export { ForwardRef as ReactComponent };